var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHatc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6331 87.7067C89.66 88.0156 94.3348 88.2949 98.0727 88.2949H100.927C104.665 88.2949 109.34 88.0156 113.367 87.7067C119.338 87.2486 125.206 85.9607 130.9 84.1026C136.453 81.3842 140.951 76.9062 143.695 71.3658L161.369 35.6747C161.973 34.4558 162.962 33.4706 164.184 32.8725C164.826 32.5582 165.518 32.3579 166.229 32.2806L176.666 31.1451C177.332 31.0727 177.879 31.6614 177.758 32.3195L158.183 139.103C158.089 139.611 157.625 139.965 157.11 139.919L147.464 139.061C144.236 138.773 141.348 136.94 139.714 134.141L130.98 119.175C127.395 113.033 120.818 109.256 113.706 109.256H100.927H98.0727H85.2936C78.1818 109.256 71.605 113.033 68.0202 119.175L59.286 134.141C57.6524 136.94 54.7638 138.773 51.5359 139.061L41.8897 139.919C41.3753 139.965 40.9106 139.611 40.8175 139.103L21.2419 32.3195C21.1212 31.6614 21.6685 31.0727 22.3337 31.1451L32.7713 32.2806C33.482 32.3579 34.1738 32.5582 34.8159 32.8725C36.0376 33.4706 37.0273 34.4558 37.6309 35.6748L55.3051 71.3658C58.0488 76.9062 62.5471 81.3842 68.1 84.1026C73.7935 85.9607 79.6615 87.2486 85.6331 87.7067Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 166V148H34.8235V155.043H53.1765V148H57V166H53.1765V158.957H34.8235V166H31Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 163V155C62 153.895 62.8954 153 64 153H82C83.1046 153 84 153.895 84 155V163C84 164.105 83.1046 165 82 165H64C62.8954 165 62 164.105 62 163Z",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 166V153H107C108.105 153 109 153.895 109 155V166",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.267 152.935H119C117.895 152.935 117 153.83 117 154.935V162.5C117 163.605 117.895 164.5 119 164.5H136.067H139V145.5",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170 164.877H149C147.895 164.877 147 163.982 147 162.877V160.306C147 159.201 147.895 158.306 149 158.306H170",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.643 152.556H167.179C168.283 152.556 169.179 153.451 169.179 154.556V159.538V166.375",
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHatc);
export default __webpack_public_path__ + "static/media/logo_hatc.c5ce9db2.svg";
export { ForwardRef as ReactComponent };